import * as Actions from 'store/actions/app/shipping_guides_cpe.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_shipping_guides_cpe: false,
  shipping_guides_cpe: [],
  total_shipping_guides_cpe: 0,

  sending_shipping_guide_to_sunat_ids: [],
  sent_shipping_guide_to_sunat_ids: [],

  sending_uninformed_shipping_guides_to_sunat: false,
  sent_uninformed_shipping_guides_to_sunat_ids: [],
}

const shippingGuidesCPEReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SHIPPING_GUIDES_CPE: {
      return {
        ...state,
        loading_shipping_guides_cpe: action.payload.loading ?? state.loading_shipping_guides_cpe,
        shipping_guides_cpe: action.payload.items ?? state.shipping_guides_cpe,
        total_shipping_guides_cpe: action.payload.total ?? state.total_shipping_guides_cpe,
      }
    }
    case Actions.SEND_SHIPPING_GUIDE_TO_SUNAT: {
      return {
        ...state,
        sending_shipping_guide_to_sunat_ids: toggleIdInArray(state.sending_shipping_guide_to_sunat_ids, action.payload.sending_id),
        sent_shipping_guide_to_sunat_ids: toggleIdInArray(state.sent_shipping_guide_to_sunat_ids, action.payload.sent_id),
        shipping_guides_cpe: action.payload.data
          ? addOrUpdateObjectInArray(state.shipping_guides_cpe, action.payload.data, 'nota_id')
          : state.shipping_guides_cpe
      }
    }
    case Actions.SEND_UNINFORMED_SHIPPING_GUIDES_TO_SUNAT: {
      return {
        ...state,
        sending_uninformed_shipping_guides_to_sunat: action.payload.sending ?? state.sending_uninformed_shipping_guides_to_sunat,
        sent_uninformed_shipping_guides_to_sunat_ids: action.payload.data ?? [],
      }
    }
    default: {
      return state
    }
  }
}
export default shippingGuidesCPEReducer
